
import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import LoadingScreen from "./components/LoadingScreen";


function App() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <I18nextProvider i18n={i18n}>
      {isLoading && <LoadingScreen onLoadingComplete={() => setIsLoading(false)} />}
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
